






























import _ from 'lodash'
import moment from 'moment'
import { Component, Watch} from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { HodidayList, IHodiday, ISchedule, ScheduleList } from '@/store/modules/views/schedule/states'
import { UserProfile } from '@/store/modules/views/userProfile/states'

@Component
export default class Excludedate extends VueExtendedBaseComponent {
  private loading = false
  private metedataExcludeDate: string[] = []
  private excludeDate: string = ''
  private confirmDeleteWorkDialog = false
  private schduleId = ''
  private schduleDate = ''

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Getter('schedule/scheduleByUserLists')
  private scheduleByUserLists!: ISchedule

  @Getter('schedule/holidayLists')
  private holidayLists!: HodidayList


  get allScheduleByUser() {
    return this.scheduleByUserLists ? _.filter(this.scheduleByUserLists, (item) => item.status !== 'รอรับงาน') : []
  }

  get mapSchedule() {
    return this.allScheduleByUser
      ? _.map(this.allScheduleByUser, (item: ISchedule) => {
        const startDateTime = this.doConvertDateTimeZone(item.startDate, item.startTime, 'T00:')
        const endDateTime = this.doConvertDateTimeZone(item.endDate, item.endTime, 'T23:')
        return {
          _id: item._id,
          name: `${item.startTime} น. - ${item.endTime} น.`,
          start: startDateTime,
          end: endDateTime,
          color: moment(`${item.endDate} ${item.endTime}`).diff(moment()) ? 'secondary' : 'grey',
          // item.jobId === this.profile.schedule.jobId ? 'secondary' : 'grey',
          timed: moment(startDateTime).diff(moment(endDateTime), 'days') === 1,
          isDialog: true,
        }
      }) : []
  }

  get mapExcludeDate() {
    return !_.isNil(this.metedataExcludeDate) && !_.isEmpty(this.metedataExcludeDate)
      ? _.map(this.metedataExcludeDate, (item) => {
        const startDateTime = this.doConvertDateTimeZone(item)
        const endDateTime = this.doConvertDateTimeZone(item)
        return {
          name: `ลาหยุด`,
          start: startDateTime,
          end: endDateTime,
          color: moment(startDateTime).diff(moment(), 'days') < 0 ? 'grey' : 'red darken-2',
          timed: moment(startDateTime).diff(moment(endDateTime), 'days') === 1,
          isDialog: false,
        }
      })
      : []
  }

  get mapHoliday() {
    return !_.isNil(this.holidayLists) && !_.isEmpty(this.holidayLists)
      ? _.map(this.holidayLists.data, (item: IHodiday) => {
          const startDateTime = this.doConvertDateTimeZone(item.date)
          const endDateTime = this.doConvertDateTimeZone(item.date)
          return {
            _id: item._id,
            name: item.name,
            start: startDateTime,
            end: endDateTime,
            color: moment(startDateTime).diff(moment(), 'days') < 0 ? 'grey' : 'info',
            timed: moment(startDateTime).diff(moment(endDateTime), 'days') === 1,
            isDialog: false,
          }
        })
      : []
  }

  get events() {
    return _.concat(this.mapExcludeDate, this.mapSchedule, this.mapHoliday)
  }

  @Action('userprofile/setMetadataExcludeDate')
  private setMetadataExcludeDate!: (data: { _id: string, date: string }) => void

  @Action('userprofile/removeMetadataExcludeDate')
  private removeMetadataExcludeDate!: (data: { _id: string, date: string }) => void

  @Action('schedule/getScheduleListByUser')
  private getScheduleListByUser!: (options: {}) => void

  @Action('schedule/getHodidayList')
  private getHodidayList!: (options: {}) => ScheduleList

  private async manageExclude(action, api) {
    this.loading = true
    const userData = {
      manage: {
        _id: this.profile._id,
        date: Buffer.from(this.excludeDate).toString('base64'),
      },
    }
    try {
      api(userData.manage)
      this.updateSnackbar({txt: `${action}ตารางวันหยุดสำเร็จ.`, type: 'success'})
      this.loading = false
    } catch (e) {
      this.loading = false
    }
  }

  private async doUpdateExcludeDate(date) {
    if (this.profile.role.name !== 'นักบริบาล') {
      return
    }
    const diff = moment(date).diff(moment().startOf('day'), 'day')
    const foundJob: ISchedule = _.find(
      this.allScheduleByUser, (item: ISchedule) => [item.startDate, item.endDate].includes(date),
    )
    // const foundHoliday = _.find(this.holidayLists.data, (item: IHodiday) => item.date === date)
    if (!_.includes(this.metedataExcludeDate, date)) {
      // if (foundHoliday) {
      //   this.updateSnackbar({txt: 'ไม่เพิ่มสามารถวันหยุดได้ เนื่องเป็นวันที่เลือกเป็นวันหยุด', type: 'error'})
      // } else {
      if (diff < 0) {
        this.updateSnackbar({txt: 'ไม่เพิ่มสามารถวันหยุดได้ เนื่องจากวันที่เลือกผ่านไปแล้ว', type: 'error'})
      } else if (diff < 2) {
        this.updateSnackbar({txt: 'ไม่เพิ่มสามารถวันหยุดได้ ควรเพิ่มวันหยุดล่วงหน้า 2 วัน', type: 'error'})
      } else {
        if (foundJob) {
          this.schduleId = foundJob._id
          this.schduleDate = foundJob.startDate
          this.confirmDeleteWorkDialog = true
        } else {
          this.doAddHoliday(date)
        }
      }
      // }
    } else {
      if (diff < 0) {
        this.updateSnackbar({txt: 'ไม่สามารถลบวันหยุดได้ เนื่องจากวันที่เลือกผ่านไปแล้ว', type: 'error'})
      } else {
        this.excludeDate = date
        this.metedataExcludeDate = _.clone(_.pull(this.metedataExcludeDate, date))
        await this.manageExclude('ลบ', this.removeMetadataExcludeDate)
      }
        //   this.updateSnackbar({txt: 'ไม่ลบสามารถวันหยุดได้ เนื่องจากวันที่เลือกผ่านไปแล้ว', type: 'error'})
        // } else {
      // if (foundJob) {
      //   this.updateSnackbar({txt: 'ไม่สามารถลบวันหยุดได้ เนื่องจากมีตารางงานอยู่', type: 'error'})
      // } else if (foundHoliday) {
      //   this.updateSnackbar({txt: 'ไม่ลบสามารถวันหยุดได้ เนื่องเป็นวันที่เลือกเป็นวันหยุด', type: 'error'})
      // } else {
        // if (diff > 172800000) {
        //   this.excludeDate = date
        //   this.metedataExcludeDate = _.clone(_.pull(this.metedataExcludeDate, date))
        //   await this.manageExclude('ลบ', this.removeMetadataExcludeDate)
        // } else if (diff < 0) {
        //   this.updateSnackbar({txt: 'ไม่ลบสามารถวันหยุดได้ เนื่องจากวันที่เลือกผ่านไปแล้ว', type: 'error'})
        // } else {
        //   this.updateSnackbar({txt: 'ไม่ลบสามารถวันหยุดได้ กรุณาลบวันหยุดล่วงหน้าอย่างน้อย 2 วัน', type: 'error'})
        // }
      // }
    }
  }

  private onConfirmAddHoliday(date) {
    this.doAddHoliday(date)
  }

  private async doAddHoliday(date) {
    this.excludeDate = date
    this.metedataExcludeDate.push(date)
    await this.manageExclude('เพิ่ม', this.setMetadataExcludeDate)
  }

  private async created() {
    this.getList()
  }

  private async getList() {
    await Promise.all([
      this.getHodidayList({}),
      this.getScheduleListByUser({
        headers: {
          filter: Buffer.from(JSON.stringify({ status: [{ condition: 'is not', value: 'รอรับงาน' }] })).toString('base64'),
        },
      }),
    ])
    this.doAssignMetadata()
  }

  private doAssignMetadata() {
    if (this.profile && this.profile.metadata && this.profile.metadata.excludeDate) {
      this.metedataExcludeDate = this.profile.metadata.excludeDate
    }
  }

  @Watch('profile', { deep: true })
  private onUpdateProfile() {
    this.doAssignMetadata()
  }
}
